  
import { ADD_TO_CART, REMOVE_FROM_CART,CART_EMPY, DECREMENT_TO_CART } from "../constants/CartType";

export const cartReducer = (
  state = { cartItems: JSON.parse(localStorage.getItem("cartItems") || "[]") },
  action
) => {
  switch (action.type) {
    case ADD_TO_CART:
      return { cartItems: action.payload.cartItems };
    case REMOVE_FROM_CART:
      return { cartItems: action.payload.cartItems };
      case DECREMENT_TO_CART:
        return { cartItems: action.payload.cartItems };
    case CART_EMPY:
      return { ...state, cartItems: [] };
    default:
      return state;
  }
};